(function() {
    'use strict';

    angular
        .module('app.variables')
        .run(appRun);

    // appRun.$inject = ['routehelper'];

    /* @ngInject */
    function appRun(routehelper) {
        routehelper.configureRoutes(getRoutes());
    }

    function getRoutes() {
        return [
            {
                url: '/variables',
                config: {
                    templateUrl: 'app/variables/variables.html',
                    controller: 'Variables',
                    controllerAs: 'vm',
                    title: 'Variables'
                }
            },
            {
                url: '/editar-variable/:id?',
                config: {
                    templateUrl: 'app/variables/editarVariable.html',
                    controller: 'EditarVariable',
                    controllerAs: 'vm',
                    title: 'EditarVariable'
                }
            }
        ];
    }
})();
